<rt-collapsible-card
  rtCollapsibleCardAnalytics
  analyticsKey="kiwiHR"
  uniqKey="rti-kiwi-hr-integration-card"
>
  <div leftSlot layout layout-align-items-center>
    <rt-icon name="tellent-apps-hr" size="small" margin-right-small-x></rt-icon>
    <rt-heading>
      {{ 'rti.kiwi_hr.name' | translate }}
    </rt-heading>
  </div>
  <div rightSlot layout layout-align-items-center>
    <rt-icon-button
      #moreDropdownTrigger="rtOverlayOrigin"
      rt-overlay-origin
      variant="plain"
      iconName="more-horiz"
      size="small"
      [pressed]="moreDropdown.open"
      (click)="onMoreClick($event, moreDropdown)"
    ></rt-icon-button>
    <ng-template
      #moreDropdown="rtConnectedOverlay"
      rt-connected-overlay
      hasBackdrop
      [origin]="moreDropdownTrigger"
      (backdropClick)="moreDropdown.toggleOverlay(false)"
    >
      <rt-dropdown>
        <rt-dropdown-item [href]="'rti.kiwi_hr.learn_more_article' | translate" hrefTarget="_blank">
          <div layout layout-align-items-center>
            <rt-icon name="book-open-page-variant" margin-right-small-x></rt-icon>
            {{ 'rti.common.learn_more' | translate }}
          </div>
        </rt-dropdown-item>
      </rt-dropdown>
    </ng-template>
  </div>
  <div collapsible layout-full-width padding-bottom-small padding-lr>
    <div layout-vertical>
      <div layout layout-align-items-center text-darkest text-small margin-bottom-small-x>
        @if (!isLoaded()) {
          <rt-placeloader variant="item" text-placeloader text-placeloader-short></rt-placeloader>
        } @else {
          @if (isProfileCreated()) {
            <rt-icon
              name="check"
              colorToken="colorIconSuccessDefault"
              margin-right-small-xx
            ></rt-icon>
          }
          {{
            (isProfileCreated()
              ? 'rti.kiwi_hr.employee_profile_created'
              : 'rti.kiwi_hr.create_profile'
            ) | translate
          }}
        }
      </div>
      @if (!isLoaded()) {
        <rt-placeloader variant="item" button-placeloader-height></rt-placeloader>
      } @else {
        <rt-button
          [variant]="isProfileCreated() ? 'primary' : 'tertiary'"
          (click)="onSendOrVisitClick()"
        >
          @if (isProfileCreated()) {
            <rt-icon
              name="open-in-new"
              size="small"
              colorToken="colorIconOnprimaryDefault"
            ></rt-icon>
          }
          {{
            (isProfileCreated()
              ? 'rti.kiwi_hr.view_in_kiwihr'
              : 'rti.kiwi_hr.send_candidate.candidate_profile_more_button'
            ) | translate
          }}
        </rt-button>
      }
    </div>
  </div>
</rt-collapsible-card>
